import { render, staticRenderFns } from "./AllotSuccess.vue?vue&type=template&id=66e4e47e&scoped=true&"
import script from "./AllotSuccess.vue?vue&type=script&lang=js&"
export * from "./AllotSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AllotSuccess.vue?vue&type=style&index=0&id=66e4e47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e4e47e",
  null
  
)

export default component.exports